import { APIGet } from "../API";
import MeContext from "../MeContext";
import React, { useContext } from "react"
import { logout } from "../session";
import { T } from "../traks";
import { LL } from "./LL";

const Logout = () => {
	const { setMe } = useContext(MeContext);
	const HandleLogout = () => {
		APIGet('logout')
			.then((res) => {
				logout()
				setTimeout(() => window.location.href = LL('/'), 100);
				setMe(null);
			})
			.catch((err) => {
				alert("couldn't log you out");
				console.log(err);
			});
	};
	return (
		<div className="vertical-footer">
			<button className="btn logout-btn light_grey_on_dark" data-cy="logout-btn" onClick={HandleLogout}>
				<img src='https://static.sibilus.eu/gfx/logout-icon-0.svg' className="dashboard_icon me-2" style={{ marginTop: '-3px' }} alt="logout_icon" />
				<span>
					<T>Logout</T>
				</span>
			</button>
		</div>
	)
}

export { Logout }

